import { jsxs, jsx } from "react/jsx-runtime";
const KEYFRAMES = `
@keyframes voice-wf-bar {
  0%, 100% { transform: scaleY(0.32); }
  50%      { transform: scaleY(1); }
}
`;
const BAR_HEIGHTS = [0.55, 0.9, 1, 0.75, 0.45];
const Waveform = ({
  active,
  bars = BAR_HEIGHTS.length,
  color = "var(--voice-header-fg, #1F2937)",
  mirror = false,
  height = 18
}) => {
  if (!active) return null;
  const indices = Array.from({ length: bars }, (_, i) => i);
  const ordered = mirror ? [...indices].reverse() : indices;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "aria-hidden": true,
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        height
      },
      children: [
        /* @__PURE__ */ jsx("style", { children: KEYFRAMES }),
        ordered.map((i, slot) => {
          const heightFactor = BAR_HEIGHTS[i % BAR_HEIGHTS.length];
          const delay = `${slot % bars * 0.11}s`;
          return /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                display: "inline-block",
                width: 3,
                height: `${heightFactor * height}px`,
                background: color,
                borderRadius: 999,
                transformOrigin: "center",
                animation: `voice-wf-bar 1.05s ease-in-out ${delay} infinite`
              }
            },
            i
          );
        })
      ]
    }
  );
};
export {
  Waveform
};
//# sourceMappingURL=Waveform.js.map
